import { defineMessages } from 'react-intl';

export default defineMessages({
  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What expenses are you claiming for?',
  },
  expensesRelatedToDeathGroup: {
    id: 'fastCover.stepOtherTugo.expensesRelatedToDeathGroup',
    defaultMessage: 'Expenses Related to Death',
  },
  accidentalDeathAndDismembermentBenefitsGroup: {
    id: 'fastCover.stepOtherTugo.accidentalDeathAndDismembermentBenefitsGroup',
    defaultMessage: 'Accidental Death and Dismemberment Benefits',
  },
  repatriationBenefitReturnOfRemains: {
    id: 'fastCover.stepOtherTugo.repatriationBenefitReturnOfRemains',
    defaultMessage: 'Repatriation Benefit (Return of Remains)',
  },
  repatriationBurialAtPlaceOfDeath: {
    id: 'fastCover.stepOtherTugo.repatriationBurialAtPlaceOfDeath',
    defaultMessage: 'Repatriation (Burial at place of death)',
  },
  returnHomeBenefit: {
    id: 'fastCover.stepOtherTugo.returnHomeBenefit',
    defaultMessage: 'Return Home Benefit',
  },
  deathRemainsBenefit: {
    id: 'fastCover.stepOtherTugo.deathRemainsBenefit',
    defaultMessage: 'Return of remains to home country',
  },
  deathBurialBenefit: {
    id: 'fastCover.stepOtherTugo.deathBurialBenefit',
    defaultMessage: 'Burial or Cremation at Place of Death',
  },
  deathTransportBenefit: {
    id: 'fastCover.stepOtherTugo.deathTransportBenefit',
    defaultMessage: 'Transportation of Family Member to Identify Remains when required',
  },
  deathExpensesDisclaimer: {
    id: 'fastCover.stepOtherTugo.deathExpensesDisclaimer',
    defaultMessage: 'Expenses related to death are payable only when pre-approved by us. Charges for funeral expenses, coffin or urn are not eligible for reimbursement.',
  },
  airFlightCommonCarrierAccidentBenefits: {
    id: 'fastCover.stepOtherTugo.airFlightCommonCarrierAccidentBenefits',
    defaultMessage: 'Air Flight/Common Carrier Accident Benefits',
  },
  airFlightCommonCarrierAccidentBenefitsTooltip: {
    id: 'fastCover.stepOtherTugo.airFlightCommonCarrierAccidentBenefitsTooltip',
    defaultMessage: 'Death or dismemberment as a result of an accident sustained during the period of coverage while riding as a fare-paying passenger, or while entering or leaving a lawfully operated licensed common carrier. Coverage is also applicable to insured children under two years accompanied by a fare paying passenger.',
  },
  accident24HourBenefits: {
    id: 'fastCover.stepOtherTugo.accident24HourBenefits',
    defaultMessage: '24 Hour Accident Benefits',
  },
  accident24HourBenefitsTooltip: {
    id: 'fastCover.stepOtherTugo.accident24HourBenefitsTooltip',
    defaultMessage: 'Death or dismemberment as a result of an accident sustained during the period of coverage in any other situation not specifically mentioned under Air Flight/Common Carrier above.',
  },
  // AD&D step labels (without "Benefits" suffix)
  adAndDAirFlightCommonCarrierAccident: {
    id: 'fastCover.adAndDBenefits.airFlightCommonCarrierAccident',
    defaultMessage: 'Air Flight/Common Carrier Accident',
  },
  adAndD24HourAccident: {
    id: 'fastCover.adAndDBenefits.24HourAccident',
    defaultMessage: '24-Hour Accident',
  },
  amountClaimed: {
    id: 'fastCover.stepOtherTugo.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  currency: {
    id: 'fastCover.stepOtherTugo.currency',
    defaultMessage: 'Currency',
  },
  selectInsuredForExpense: {
    id: 'fastCover.stepOtherTugo.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },
  expenseFor: {
    id: 'fastCover.stepOtherTugo.expenseFor',
    defaultMessage: 'Expense For',
  },
  descriptionOfExpense: {
    id: 'fastCover.stepOtherTugo.descriptionOfExpense',
    defaultMessage: 'Description of Expense',
  },
  isRequired: {
    id: 'fastCover.stepOtherTugo.isRequired',
    defaultMessage: '\'{defaultMessage}\' is required',
  },
  addItem: {
    id: 'fastCover.stepOtherTugo.addItem',
    defaultMessage: 'Add Expense',
  },
  dateOfExpenses: {
    id: 'fastCover.stepOtherTugo.dateOfExpenses',
    defaultMessage: 'Date of Expense',
  },
  otherUnrelatedBenefit: {
    id: 'fastCover.stepOtherTugo.otherUnrelatedBenefit',
    defaultMessage: 'Other (unrelated to any benefit listed above)',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StepOther/messages.js